import { useState } from "react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "./ui/sheet";
import { History, CheckCircle2 } from "lucide-react";
import { loadHistory, clearHistory } from "../lib/api";

export const HistorySheet = ({ t, onOpenItem }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const toggle = (o) => { setOpen(o); if (o) setItems(loadHistory()); };
  return (
    <Sheet open={open} onOpenChange={toggle}>
      <SheetTrigger asChild>
        <button data-testid="history-open-btn" className="h-10 whitespace-nowrap rounded-full border border-slate-200 bg-white/90 px-3 text-xs font-semibold text-slate-700 shadow-sm backdrop-blur transition-colors hover:bg-white hover:text-slate-900 sm:px-4 sm:text-sm">{t("history")}</button>
      </SheetTrigger>
      <SheetContent aria-describedby={undefined} className="border-slate-200 bg-white text-slate-800" data-testid="history-sheet">
        <SheetTitle className="font-display text-2xl text-slate-900">{t("history")}</SheetTitle>
        <div className="mt-6 space-y-2 overflow-y-auto">
          {items.length === 0 && <p className="text-sm text-slate-500" data-testid="history-empty">{t("noHistory")}</p>}
          {items.map((h) => (
            <button key={h.id} data-testid={`history-item-${h.id}`} onClick={() => { setOpen(false); onOpenItem(h.id); }}
              className="w-full rounded-xl border border-slate-200 bg-white p-3 text-left transition-colors hover:border-teal-600">
              <div className="flex items-center justify-between">
                <span className="font-semibold text-slate-800">{h.zone_label}</span>
                {h.done && <CheckCircle2 size={16} className="text-teal-700" />}
              </div>
              <p className="text-sm text-slate-500">{h.subzone_label}</p>
              <p className="mt-1 text-xs text-slate-500">{new Date(h.date).toLocaleString()}</p>
            </button>
          ))}
        </div>
        {items.length > 0 && (
          <button data-testid="history-clear-btn" onClick={() => { clearHistory(); setItems([]); }} className="mt-6 text-sm text-red-600 hover:underline">{t("clear")}</button>
        )}
      </SheetContent>
    </Sheet>
  );
};
